import React from "react";
import { Facebook, Twitter, Instagram } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { resolveImg } from "./adminApi";

const slugify = (s) => (s || "event").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Brand glyphs not shipped by lucide — inline single-path SVGs.
const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);
const ViberIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.302 4.187.696 6.7.633 9.817.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.416s-.037.977.607 1.177c.782.246 1.243-.514 1.987-1.317.407-.44.97-1.084 1.395-1.578 3.85.324 6.812-.416 7.15-.526.776-.252 5.176-.816 5.892-6.657.74-6.02-.36-9.83-2.34-11.55l-.008-.007c-.6-.55-3-2.31-8.36-2.334 0 0-.395-.025-1.038-.01zm.058 1.68c.545-.004.874.017.874.017 4.537.017 6.703 1.373 7.207 1.831 1.674 1.435 2.527 4.902 1.902 9.932v.003c-.604 4.877-4.174 5.185-4.832 5.395-.28.09-2.906.72-6.176.507 0 0-2.44 2.946-3.202 3.712-.12.119-.259.167-.351.144-.13-.033-.166-.188-.165-.415l.021-4.005c-4.774-1.323-4.494-6.298-4.442-8.9C3.573 7.11 4.043 5.035 5.5 3.6 7.474 1.788 10.996 1.68 11.458 1.68zm.526 2.556a.24.24 0 00-.24.24.24.24 0 00.24.243c1.984.014 3.416.67 4.4 1.693.984 1.026 1.484 2.537 1.51 4.502a.24.24 0 00.243.238.24.24 0 00.237-.242c-.028-2.062-.564-3.717-1.646-4.844-1.084-1.128-2.637-1.82-4.744-1.833zm.816 1.36a.24.24 0 00-.03.48c1.362.104 2.017.79 2.109 2.212a.24.24 0 00.256.224.24.24 0 00.224-.256c-.106-1.643-.987-2.573-2.55-2.68a.24.24 0 00-.01 0zm.824 1.4a.24.24 0 00-.216.263.24.24 0 00.263.216c.542-.056.87.29.895.895a.24.24 0 00.25.23.24.24 0 00.23-.25c-.036-.862-.564-1.442-1.422-1.354a.24.24 0 00-.001 0zm-3.35.02c-.198-.017-.42.06-.616.17-.39.219-.744.53-.89.98-.104.322-.08.658.053.968.394.925 1.01 1.74 1.844 2.42.408.33.85.61 1.32.83.06.028.123.052.187.07.238.07.463.052.66-.108.124-.1.23-.223.34-.34.104-.11.202-.23.257-.373.077-.199.03-.372-.12-.497-.315-.263-.643-.51-.982-.735-.226-.15-.455-.135-.636.08l-.15.176c-.077.09-.176.104-.288.058a3.89 3.89 0 01-1.253-.883 3.9 3.9 0 01-.572-.75c-.052-.09-.045-.17.023-.25.076-.088.166-.166.245-.253.158-.174.17-.372.048-.573a7.75 7.75 0 00-.612-.86c-.09-.11-.203-.16-.35-.15z" />
  </svg>
);

async function downloadImage(src, filename) {
  try {
    const res = await fetch(src, { mode: "cors" });
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objUrl);
    return true;
  } catch {
    window.open(src, "_blank", "noopener,noreferrer");
    return false;
  }
}

/**
 * Social share buttons for an event (Option A — native share dialogs, no APIs/keys).
 * Facebook / X / WhatsApp / Viber open a pre-filled composer; Instagram copies caption + saves image.
 */
export default function ShareButtons({ event, size = "md", className = "" }) {
  const { toast } = useToast();
  if (!event) return null;

  const slug = slugify(event.title);
  const url = `${window.location.origin}/events`;
  const host = window.location.host;
  const meta = [event.tag, event.date, event.level].filter(Boolean).join(" · ");

  const shareText = `🎾 ${event.title} at The Supreme Courts!${event.date ? ` ${event.date}` : ""}${event.level ? ` · ${event.level}` : ""}`;
  const igCaption =
    `🎾 ${event.title}\n` +
    `📅 ${[event.date, event.level, event.tag].filter(Boolean).join(" · ")}\n\n` +
    `Game on at The Supreme Courts — the Philippines' premier pickleball & padel destination in Sucat, Parañaque. 🏆\n` +
    `Grab your paddle and lock in your spot 👉 ${host}\n\n` +
    `#TheSupremeCourts #Pickleball #Padel #PickleballPH #PadelPH #Parañaque #Sucat #RTSports #DUPR`;

  const openPopup = (shareUrl) => window.open(shareUrl, "_blank", "noopener,noreferrer,width=620,height=640");

  const onFacebook = () => openPopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
  const onX = () => openPopup(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(url)}`);
  const onWhatsApp = () => openPopup(`https://wa.me/?text=${encodeURIComponent(`${shareText}\n${url}`)}`);
  const onViber = () => { window.location.href = `viber://forward?text=${encodeURIComponent(`${shareText}\n${url}`)}`; };

  const onInstagram = async () => {
    try {
      await navigator.clipboard.writeText(igCaption);
    } catch {
      /* clipboard may be blocked; still try the image */
    }
    if (event.image) await downloadImage(resolveImg(event.image), `${slug}.jpg`);
    toast({
      title: "Instagram post ready",
      description: "Caption copied & image saved. Open Instagram, start a new post and paste the caption.",
    });
  };

  const btn =
    size === "sm"
      ? "w-7 h-7 rounded-full border border-white/10 text-white/40 hover:border-sc-lime hover:text-sc-lime flex items-center justify-center transition-colors"
      : "w-9 h-9 rounded-full border border-white/15 text-white/60 hover:border-sc-lime hover:text-sc-lime flex items-center justify-center transition-colors";
  const icon = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={`share-buttons-${slug}`}>
      {size !== "sm" && (
        <span className="font-mono2 text-[10px] uppercase tracking-widest text-white/40 mr-1">Share</span>
      )}
      <button type="button" onClick={onFacebook} aria-label="Share on Facebook" title="Share on Facebook" className={btn} data-testid={`share-facebook-${slug}`}>
        <Facebook className={icon} />
      </button>
      <button type="button" onClick={onX} aria-label="Share on X" title="Share on X (Twitter)" className={btn} data-testid={`share-x-${slug}`}>
        <Twitter className={icon} />
      </button>
      <button type="button" onClick={onInstagram} aria-label="Share on Instagram" title="Copy caption & image for Instagram" className={btn} data-testid={`share-instagram-${slug}`}>
        <Instagram className={icon} />
      </button>
      <button type="button" onClick={onWhatsApp} aria-label="Share on WhatsApp" title="Share on WhatsApp" className={btn} data-testid={`share-whatsapp-${slug}`}>
        <WhatsAppIcon className={icon} />
      </button>
      <button type="button" onClick={onViber} aria-label="Share on Viber" title="Share on Viber" className={btn} data-testid={`share-viber-${slug}`}>
        <ViberIcon className={icon} />
      </button>
    </div>
  );
}
